import { Link } from 'react-router-dom';

interface ArticleCardProps {
  id: number;
  title: string;
  category: string;
  categoryName: string;
  author: string;
  date: string;
  summary: string;
  imageUrl: string;
}

export default function ArticleCard({
  id,
  title,
  category,
  categoryName,
  author,
  date,
  summary,
  imageUrl,
}: ArticleCardProps) {
  return (
    <article className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200/60 transition-all duration-300 group cursor-pointer">
      <Link to={`/article/${id}`} className="block">
        <div className="relative w-full h-48 overflow-hidden">
          <img
            src={imageUrl}
            alt={title}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            title={`${title} - 新金瓶梅`}
          />
        </div>
        <div className="p-5">
          <div className="flex items-center gap-3 mb-3 flex-wrap">
            <Link
              to={`/category/${category}`}
              className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-primary-100/70 text-primary-700 hover:bg-primary-200 transition-colors duration-200"
            >
              {categoryName}
            </Link>
            <span className="text-xs text-foreground-400">{date}</span>
          </div>
          <h3 className="text-lg font-heading font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2">
            {title}
          </h3>
          <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-4">
            {summary}
          </p>
          <div className="flex items-center text-xs text-foreground-400">
            <span className="w-4 h-4 flex items-center justify-center mr-1">
              <i className="ri-user-line text-xs"></i>
            </span>
            {author}
          </div>
        </div>
      </Link>
    </article>
  );
}